// removed by extract-text-webpack-plugin
module.exports = {"header":"_2YMDq5M_CYD_CBbRcr7eBf","inner":"McjjhwG3gNhHeHBl97hLq","filters":"_1NRqAJk4NgNo81aibz9rdd","list-outer":"_3t-T7CkR13-NMdr2iBmmrA","list":"_1w7QXPUN3Aq-pc0C5gQdPF","searching":"_12rUSUFKgjgr3zvvs-eaXq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PressReleaseBlock/PressReleaseBlock.module.scss
// module id = 795
// module chunks = 0